import { useMutation, useQuery } from 'react-query';
import { network } from 'services/network';
import { IComment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

const createEditComment = (params) => {
    return network
        .post('api/bo/createOrUpdateCardComment', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const deleteComment = (id) => {
    const url = `api/bo/removeCardComment?commentId=${id}`;

    return network
        .get(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const generateMitigation = (params) => {
    return network
        .post('api/bo/chat/getAiTaskMitigation', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const generateSubTaskMitigation = (params) => {
    return network
        .post('api/bo/chat/getAiSubTaskMitigation', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const generateResourceMitigation = (params) => {
    return network
        .post('api/bo/chat/getAiResourcesMitigation', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const generateRiskSummaryMitigation = (params) => {
    return network
        .post('api/bo/chat/getAiRiskSummary', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getCardComment = (params) => {
    const url = `api/bo/getCardComment?cardId=${params.id}&isVirtual=${params.isVirtual}`;

    return network
        .post(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useMutationCreateEditComment = () => {
    return useMutation<IComment, QueryError, ICreateEditCommentPayload>((params) => createEditComment(params));
};

export const useMutationDeleteComment = () => {
    return useMutation<string, QueryError, number>((id) => deleteComment(id));
};

export const useMutationGenerateMitigation = () => {
    return useMutation<IGenerateMitigationResponse, QueryError, IGenerateMitigationPayload>((params) =>
        generateMitigation(params),
    );
};

export const useMutationGenerateSubTaskMitigation = () => {
    return useMutation<IGenerateMitigationResponse, QueryError, IGenerateMitigationPayload>((params) =>
        generateSubTaskMitigation(params),
    );
};

export const useMutationGenerateResourcesMitigation = () => {
    return useMutation<IGenerateMitigationResponse, QueryError, IGenerateMitigationPayload>((params) =>
        generateResourceMitigation(params),
    );
};

export const useMutationGenerateRiskSummaryMitigation = () => {
    return useMutation<IGenerateMitigationResponse, QueryError, IGenerateMitigationPayload>((params) =>
        generateRiskSummaryMitigation(params),
    );
};

export const useQueryGetCardComments = (params) => {
    return useQuery<IComment[], QueryError>(['getCardComment', params], () => getCardComment(params), {
        enabled: Boolean(params.id),
    });
};

export interface ICreateEditCommentPayload {
    cardId: number | undefined;
    comment: string;
    id: number | null;
    mentionedList: string[];
    isVirtual: boolean;
}

interface IGenerateMitigationPayload {
    taskId: number;
    laneId: string | number;
    isVirtual: boolean;
    cardId: number | null;
    versionId: number;
}

interface IGenerateMitigationResponse {
    mitigation: string;
    taskId: number;
}
